import { createSelector } from '@ngrx/store';
import { getDotCmsState } from '../dot-cms-store';

export const getDotCmsContainerState = createSelector(getDotCmsState, state => state.containers);

export const getDotCmsContainerByIdentifier = (identifier: string) =>
  createSelector(getDotCmsContainerState, container => container[identifier]);
